import axios from "axios";

export default {
  get(data) {
    const params = new URLSearchParams();
    params.append("customerNumbers", data.customerNumbers.join(","));
    params.append("contractId", data.contractId);

    return axios.get("/api/files", {
      params,
    });
  },
  getByCustomer(customerId) {
    return axios.get(`/api/files/customer/${customerId}`);
  },
  store(data, customerNumbers, contractId, docType) {
    const params = new URLSearchParams();
    params.append("customerNumbers", customerNumbers.join(","));
    params.append("contractId", contractId);
    params.append("docType", docType);

    const formData = new FormData();
    formData.append("file", data);

    return axios.post("/api/Files/upload", formData, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  downloadFile(fileId) {
    return axios.get(`/api/files/${fileId}`, {
      responseType: "blob", // Important pour gérer les fichiers binaires
    });
  },
  delete(id) {
    return axios.delete(`/api/files/${id}`);
  },
  updateAccess(id, file) {
    return axios.put(`/api/files/${id}/access`, file);
  },
  getFileAvantage(name) {
    const params = new URLSearchParams();
    params.append("fileName", name);

    return axios.get(`/api/files/avantage`, {
      params,
    });
  },
};
